import { applyRenderScale } from '../render/render-scale';
import Phaser from 'phaser';
import { uiManager } from '../ui-instance';

export class BootScene extends Phaser.Scene {
  constructor() {
    super('BootScene');
  }

  create(): void {
    uiManager.showLoading();
    this.cameras.main.setBackgroundColor('#050817');
    applyRenderScale(this.cameras.main);
    this.time.delayedCall(420, () => this.scene.start('MenuScene'));
  }
}
